/**
 * 待办
 */
import http from './http';

// 待处理待办列表
export const getUnhandledTaskList = (data) => {
  return http({
    method: 'POST',
    url: '/reminder/page/unhandled',
    data,
  });
};

// 获取所有待办列表
export const getAllTaskList = (data) => {
  return http({
    method: 'POST',
    url: '/reminder/page',
    data,
  });
};

// 创建待办
export const createTaskItem = (data) => {
  return http({
    method: 'POST',
    url: '/reminder',
    data,
  });
};

// 修改待办
export const updateTaskItem = (data) => {
  return http({
    method: 'PUT',
    url: '/reminder',
    data,
  });
};

// 处理待办
export const updateTaskStatus = (data) => {
  return http({
    method: 'POST',
    url: '/reminder/handle',
    data,
  });
};
